import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

let els = document.getElementsByTagName("app");

for (let i = 0; i < els.length; i++) {
    ReactDOM.createRoot(els[i]).render(<App data={els[i].dataset} />);
}